// TODO: remove from `core-js@4`
var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

defineWellKnownSymbol('replaceAll');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/esnext.symbol.replace-all.js
// module id = 1104
// module chunks = 0